import _isEmpty from 'lodash/isEmpty';
import {
  formatCurrency,
  formatNumber,
  wrNormalizeNumber,
} from '../../utility/worldReadyUtils';

export const MAX_GOAL_AMOUNT_LENGTH = 11;

export function formatAmount(value) {
  if (!value && value !== 0) {
    return 0;
  }
  if (typeof value === 'number') {
    return value;
  }
  return wrNormalizeNumber(value);
}

export function normalizeNumber(amount) {
  if (!amount && amount !== 0) {
    return '';
  }
  if (typeof amount === 'number') {
    return amount;
  }
  return wrNormalizeNumber(amount);
}

export function formatCurrencyAsISOFormat(params) {
  return formatCurrency(params.value, {
    currency: params.currency,
    style: 'international',
  });
}

export function formatCurrencyNoDecimals(params, format) {
  if (!params.value || !params.currency) {
    return '';
  }
  const options = {
    currency: params.currency,
    maximumFractionDigits: 0,
    style: format ? 'symbol' : 'international',
  };

  return formatCurrency(params.value, options);
}

export function displayCurrency(amount, currency, { noDecimals = false } = {}) {
  const options = { currency };
  const numericAmount = Number(amount);

  if (numericAmount % 1 === 0 || noDecimals) {
    options.maximumFractionDigits = 0;
  }

  return formatCurrency(numericAmount, options);
}

export function displayPercentage(amount) {
  return formatNumber(amount, { style: 'percent' });
}

export function formatNumberDecimals(value) {
  if (!value) {
    return '';
  }

  return formatNumber(value, { maximumFractionDigits: 2 });
}

export function getCurrencyPartByType(currencyParts, type) {
  const currencyPart =
    currencyParts && currencyParts.find((item) => item.type === type);

  return currencyPart && currencyPart.value;
}

export function formatAmountToOnlyNumbers(amount) {
  if (_isEmpty(amount)) {
    amount = '0';
  }

  return wrNormalizeNumber(amount);
}

export const MIN_INPUT_WIDTH = 91;
export const DEFAULT_INPUT_FONTSIZE = 44;
const DIGITS_TO_FONT_SIZE_MAPPING = {
  8: 42,
  9: 40,
  10: 38,
};

export function getFontSize(value, isMobile) {
  const digitCount = value.replace(/[\.,]/g, '').length;

  if (digitCount < 8) {
    return DEFAULT_INPUT_FONTSIZE;
  }

  return DIGITS_TO_FONT_SIZE_MAPPING[`${digitCount}`] || 44;
}

export function getInputWidth(field, text) {
  text = text || '0.00';

  // Get styles from the element
  const currentStyles = window.getComputedStyle(field) || {};
  const { fontWeight } = currentStyles;
  const fontSize = `${getFontSize(text)}px`;

  // Create a span element outside visible area
  const spanElem = document.createElement('span');
  spanElem.style.fontSize = fontSize;
  spanElem.style.fontFamily = 'PayPalSansBig-Regular';
  spanElem.style.fontWeight = fontWeight || '400';
  spanElem.style.position = 'fixed';
  spanElem.style.top = '-1000px';
  spanElem.style.left = '-1000px';
  spanElem.innerHTML = text;
  document.body.appendChild(spanElem);

  // Get width of the span and then remove it
  const width = spanElem.getBoundingClientRect().width + 2; // increase by 2px to fix a layout problem in Safari iOS browser.
  document.body.removeChild(spanElem);

  if (width < MIN_INPUT_WIDTH) {
    return MIN_INPUT_WIDTH;
  }
  return width;
}

export function roundUpCurrency(number, currency) {
  const roundedUpValue = Math.ceil(number);
  return formatCurrency(roundedUpValue, { currency, maximumFractionDigits: 0 });
}
